import { experimentalQueryParamEncoding } from "#nuxt-graphql-middleware/config";
import { CLIENT_CONTEXT_PREFIX, OPERATION_HASH_PREFIX } from "../settings/index.js";
export function encodeVariables(variables) {
  if (typeof variables !== "object" || !variables) {
    return {};
  }
  if (!experimentalQueryParamEncoding) {
    for (const key in variables) {
      if (typeof variables[key] !== "string") {
        return {
          __variables: JSON.stringify(variables)
        };
      }
    }
    return variables;
  }
  const result = {};
  let needsFallback = false;
  for (const key in variables) {
    const value = variables[key];
    const type = typeof value;
    if (type === "string") {
      result[key] = value;
    } else if (type === "number") {
      result[`n:${key}`] = String(value);
    } else if (type === "boolean") {
      result[`b:${key}`] = String(value);
    } else {
      needsFallback = true;
      break;
    }
  }
  if (needsFallback) {
    return {
      __variables: JSON.stringify(variables)
    };
  }
  return result;
}
function filterValidKeys(validKeys, obj) {
  return validKeys.reduce((acc, key) => {
    const value = obj[key];
    if (value !== void 0 && value !== null) {
      acc[key] = value;
    }
    return acc;
  }, {});
}
export function decodeVariables(query, validKeys) {
  try {
    if (query.__variables && typeof query.__variables === "string") {
      return sortQueryParams(JSON.parse(query.__variables));
    }
  } catch {
  }
  if (!experimentalQueryParamEncoding) {
    if (validKeys) {
      return filterValidKeys(validKeys, query);
    }
    return query;
  }
  if (validKeys && validKeys.length === 0) {
    return {};
  }
  const result = {};
  for (const key in query) {
    if (key.startsWith(CLIENT_CONTEXT_PREFIX) || key.startsWith(OPERATION_HASH_PREFIX)) {
      continue;
    } else if (key.startsWith("n:")) {
      const actualKey = key.substring(2);
      if (validKeys && !validKeys.includes(actualKey)) {
        continue;
      }
      result[actualKey] = Number(query[key]);
    } else if (key.startsWith("b:")) {
      const actualKey = key.substring(2);
      if (validKeys && !validKeys.includes(actualKey)) {
        continue;
      }
      result[actualKey] = query[key] === "true";
    } else if (key !== "__variables") {
      if (validKeys && !validKeys.includes(key)) {
        continue;
      }
      result[key] = query[key];
    }
  }
  return sortQueryParams(result);
}
export function sortQueryParams(obj) {
  const sortedKeys = Object.keys(obj).sort();
  const sortedObj = {};
  for (const key of sortedKeys) {
    sortedObj[key] = obj[key];
  }
  return sortedObj;
}
